var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-wrap-new m-pc",style:({
    background:
      _vm.extras1.formBg.colorOrBg == 'color'
        ? _vm.extras.formBg.color
        : 'url(' + _vm.extras.formBg.src + ')',
  })},[(_vm.extras1 && _vm.extras1.formLogo.display == '1')?_c('div',{staticClass:"semianr-logo"},[_c('img',{attrs:{"src":_vm.isSetting != '1'
          ? _vm.extras1.headerLogo && _vm.extras1.headerLogo.src
          : './images/logo_new.png',"alt":""}})]):_vm._e(),(_vm.isSetting != '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.seminarInfo.display == '1')?_c('div',{staticClass:"seminar-info-new",class:_vm.extras1.BannerText.textAlign},[_c('div',{staticClass:"content"},[(_vm.extras1.textSetting.subTitle != 'hide')?_c('div',{staticClass:"seminar-title",style:({
            color:
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.fontColor
                : '',

            'font-style':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras1.textSetting.subTitle == 'custom'
                ? _vm.extras1.textSetting.fontWeight == 'on'
                  ? '900'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting.text)+" ")]):_vm._e(),(_vm.extras1.textSetting.title != 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
            color:
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.fontColor2
                : '',

            'font-style':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.fontTilt2 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras1.textSetting.title == 'custom'
                ? _vm.extras1.textSetting.fontWeight2 == 'on'
                  ? '900'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting.title == "default" ? _vm.seminarInfo.title : _vm.seminarInfo.title)+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras1.textSetting.timeTitle != 'hide'),expression:"extras1.textSetting.timeTitle != 'hide'"}],staticClass:"_title",style:({
              color:
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.fontColor3
                  : '',
              background: _vm.extras1.textSetting.bgColor5 || '',
              'font-style':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.fontTilt3 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras1.textSetting.timeTitle == 'custom'
                  ? _vm.extras1.textSetting.fontWeight3 == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting.timeTitle == "custom" ? _vm.extras1.textSetting.text3 : "会议时间")+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras1.textSetting.time != 'hide'),expression:"extras1.textSetting.time != 'hide'"}],staticClass:"_time",style:({
              color:
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.fontColor4
                  : '',
              background: _vm.extras1.textSetting.bgColor6 || '',
              'font-style':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.fontTilt4 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                _vm.extras1.textSetting.time == 'custom'
                  ? _vm.extras1.textSetting.fontWeight4 == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime))+" ")])])])]):_vm._e()]):_vm._e(),(_vm.isSetting == '1')?_c('div',{staticClass:"seminar-info"},[(_vm.extras1 && _vm.extras1.seminarInfo.display == '1')?_c('div',{staticClass:"seminar-info-new"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"seminar-title"},[_vm._v("会议会议标题会议标题标题")]),_c('div',{staticClass:"seminar-slogan"},[_vm._v("会议副标题")]),_c('div',{staticClass:"semianr-time"},[_c('div',{staticClass:"_title"},[_vm._v(" "+_vm._s("会议时间")+" ")]),_c('div',{staticClass:"_time"},[_vm._v(" "+_vm._s("2023.12.12-12.13")+" ")])])])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"field-area verify",style:({
      background:
        _vm.extras.formFieldBg.colorOrBg == 'color'
          ? _vm.extras.formFieldBg.color
          : 'url(' + _vm.extras.formFieldBg.src + ')',
    })},[(_vm.extras.verifyTitle.display == 1)?_c('h4',{staticClass:"title",class:_vm.extras.verifyTitle.textAlign,style:({
        'letter-spacing': _vm.extras.verifyTitle.wordWidth + 'px',
        color:
          _vm.extras1.verifyTitle.verifyTitleTextStyle == 'custom'
            ? _vm.extras1.verifyTitle.fontColor
            : '',
        'font-size':
          _vm.extras1.verifyTitle.verifyTitleTextStyle == 'custom'
            ? _vm.extras1.verifyTitle.fontSize + 'px'
            : '',
        'font-style':
          _vm.extras1.verifyTitle.verifyTitleTextStyle == 'custom'
            ? _vm.extras1.verifyTitle.fontTilt == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          _vm.extras1.verifyTitle.verifyTitleTextStyle == 'custom'
            ? _vm.extras1.verifyTitle.fontWeight == 'on'
              ? '900'
              : ''
            : '',
      })},[_vm._v(" "+_vm._s(_vm.extras1.verifyTitle.verifyTitleTextStyle == "custom" ? _vm.extras1.verifyTitle.title : "身份验证")+" ")]):_vm._e(),_c('div',{staticClass:"tab-input"},[(_vm.extraItem.extras('formfield.model') == 'style1')?_c('div',[_c('div',{staticClass:"must style1"},[_c('div',{staticClass:"u-label"},[_vm._v(" "+_vm._s(_vm.identityPlaceholder || _vm.identityPlaceholderDefault)+" ")]),_c('a-input',{staticClass:"verify-input",class:{ err: _vm.error.identityText },attrs:{"placeholder":_vm.identityPlaceholder || _vm.identityPlaceholderDefault},model:{value:(_vm.identity),callback:function ($$v) {_vm.identity=$$v},expression:"identity"}}),_c('div',{staticClass:"u-reg-err-tips"},[_vm._v(_vm._s(_vm.error.identityText))])],1),_c('div',{staticClass:"must style1",style:({
            display:
              _vm.extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
          })},[_c('div',{staticClass:"u-label"},[_vm._v("验证码")]),_c('div',{staticClass:"verify-con",staticStyle:{"display":"flex"}},[_c('a-input',{staticClass:"verify-input",class:{ err: _vm.error.codeText },attrs:{"placeholder":"验证码"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_c('a-button',{staticClass:"verify-button-back",attrs:{"type":"primary","disabled":_vm.isRunning},on:{"click":function($event){return _vm.sendCode()}}},[_vm._v(_vm._s(_vm.isRunning ? _vm.initialNum + "s以后重新发送" : "发送验证码"))])],1),_c('div',{staticClass:"u-reg-err-tips"},[_vm._v(_vm._s(_vm.error.codeText))])])]):_vm._e(),(_vm.extraItem.extras('formfield.model') == 'style2')?_c('div',[_c('div',{staticClass:"must style2"},[_c('div',{staticClass:"m-input-content"},[_c('div',{staticClass:"opacityText"},[_vm._v(" "+_vm._s(_vm.identityPlaceholder || _vm.identityPlaceholderDefault)+" ")]),_c('a-input',{staticClass:"verify-input status-input",class:{ err: _vm.error.identityText },model:{value:(_vm.identity),callback:function ($$v) {_vm.identity=$$v},expression:"identity"}}),_c('div',{staticClass:"u-label",class:{ moved: _vm.identity }},[_vm._v(" "+_vm._s(_vm.identityPlaceholder || _vm.identityPlaceholderDefault)+" ")])],1),_c('div',{staticClass:"u-reg-err-tips"},[_vm._v(_vm._s(_vm.error.identityText))])]),_c('div',{staticClass:"must style2",style:({
            display:
              _vm.extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
          })},[_c('div',{staticClass:"verify-con"},[_c('div',{staticClass:"opacityText"},[_vm._v("验证码")]),_c('a-input',{staticClass:"verify-input status-input",class:{ err: _vm.error.codeText },model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_c('div',{staticClass:"u-label",class:{ moved: _vm.code }},[_vm._v("验证码")]),_c('a',{staticClass:"verify-button",attrs:{"type":"primary","disabled":_vm.isRunning},on:{"click":function($event){return _vm.sendCode()}}},[_vm._v(_vm._s(_vm.isRunning ? _vm.initialNum + "s以后重新发送" : "发送验证码"))])],1),_c('div',{staticClass:"u-reg-err-tips pull-absolute"},[_vm._v(" "+_vm._s(_vm.error.codeText)+" ")])])]):_vm._e(),_c('div',{staticClass:"verify-tip"},[(_vm.extras.unSignButton && _vm.extras.unSignButton.text != 'hide')?_c('span',{style:({
            color:
              _vm.extras1.unSignButton.text == 'custom'
                ? _vm.extras1.unSignButton.fontColor
                : '',
            'font-size':
              _vm.extras1.unSignButton.text == 'custom'
                ? _vm.extras1.unSignButton.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras1.unSignButton.text == 'custom'
                ? _vm.extras1.unSignButton.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras1.unSignButton.text == 'custom'
                ? _vm.extras1.unSignButton.fontWeight == 'on'
                  ? '900'
                  : ''
                : '',
          })},[_vm._v(_vm._s(_vm.extras1.unSignButton.text2 == "custom" ? _vm.extras1.unSignButton.content : "尚未报名？"))]):_vm._e(),(_vm.extras.unSignButton && _vm.extras.unSignButton.text2 != 'hide')?_c('router-link',{staticClass:"go-sign",style:({
            color:
              _vm.extras1.unSignButton.text2 == 'custom'
                ? _vm.extras1.unSignButton.fontColor2
                : '',
            'font-size':
              _vm.extras1.unSignButton.text2 == 'custom'
                ? _vm.extras1.unSignButton.fontSize2 + 'px'
                : '',
            'font-style':
              _vm.extras1.unSignButton.text2 == 'custom'
                ? _vm.extras1.unSignButton.fontTilt2 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras1.unSignButton.text2 == 'custom'
                ? _vm.extras1.unSignButton.fontWeight2 == 'on'
                  ? '900'
                  : ''
                : '',
          }),attrs:{"to":_vm.signUp}},[_vm._v(_vm._s(_vm.extras1.unSignButton.text2 == "custom" ? _vm.extras1.unSignButton.content : "点击报名"))]):_vm._e()],1),_c('a-button',{staticClass:"verify-submit",style:({
          width: _vm.extras.verifyButton.buttonWidth + '%',
          color:
            _vm.extras1.verifyButton.buttonTextStyle == 'custom'
              ? _vm.extras1.verifyButton.fontColor
              : '',
          'font-size':
            _vm.extras1.verifyButton.buttonTextStyle == 'custom'
              ? _vm.extras1.verifyButton.fontSize + 'px'
              : '',
          'font-style':
            _vm.extras1.verifyButton.buttonTextStyle == 'custom'
              ? _vm.extras1.verifyButton.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            _vm.extras1.verifyButton.buttonTextStyle == 'custom'
              ? _vm.extras1.verifyButton.fontWeight == 'on'
                ? '900'
                : ''
              : '',
        }),attrs:{"type":"primary"},on:{"click":function($event){return _vm.submitVerify()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"verifyButton.text")))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }